/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { setRuntimeVariable } from '../../actions/runtime';
import { connect } from 'react-redux';

import s from './PageFontResizer.scss';

class PageFontResizer extends React.Component{

    increaseFontSize = (e) => {
        e.preventDefault()
        this.props.setRuntimeVariable({name: "fontSize", value: this.props.fontSize + 0.2})
    }

    decreaseFontSize = (e) => {
        e.preventDefault()
        this.props.setRuntimeVariable({name: "fontSize", value: this.props.fontSize - 0.2})
    }

    render() {
        return (
        <div className={'dlaSlepych'}>
            <ul>
                <li><button style={this.props.buttonStyle ? this.props.buttonStyle : null} onClick={this.increaseFontSize.bind(this)} type="submit">A<sup>+</sup></button></li>
                <li><button style={this.props.buttonStyle ? this.props.buttonStyle : null} onClick={this.decreaseFontSize.bind(this)} type="submit">A<sup>-</sup></button></li>
            </ul>
         </div>
        )
    }
}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
});

const mapDispatch = {
  setRuntimeVariable,
};

const PageFontResize = connect(mapState, mapDispatch)(PageFontResizer);


export default withStyles(s)(PageFontResize);


// WEBPACK FOOTER //
// src/components/PageFontResizer/PageFontResizer.js